import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { UsersTokenPlanTokenInterface } from '../../../interfaces/interfaces';

export const getUsersTokenPlanTokensColumns = (
  openUseTokenDialog: (row: UsersTokenPlanTokenInterface) => void,
  restoreToken: (row: UsersTokenPlanTokenInterface) => void,
  openAddTokensDialog: (row: UsersTokenPlanTokenInterface) => void
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'tokenPlanPurchaseHistoryId', headerName: 'Purchase History ID', width: 150 },
  { field: 'userId', headerName: 'User ID', width: 100 },
  { field: 'value', headerName: 'Value', width: 90 },
  { field: 'usedAt', headerName: 'Used At', width: 160 },
  { field: 'notes', headerName: 'Notes', width: 180 },
  { field: 'usedFor', headerName: 'Used For', width: 140 },
  { field: 'active', headerName: 'Active', width: 90, type: 'boolean' },
  { field: 'created_at', headerName: 'Created', width: 150 },
  { field: 'updated_at', headerName: 'Updated', width: 150 },
  {
    field: 'UseToken',
    headerName: 'Use Token',
    width: 110,
    renderCell: (params) => (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => openUseTokenDialog(params.row)}
      >
        Use Token
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'restoreToken',
    headerName: 'Restore Token',
    width: 140,
    renderCell: (params) => (
      <Button
        color="secondary"
        variant="outlined"
        size="small"
        onClick={() => restoreToken(params.row)}
      >
        Restore
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'addTokens',
    headerName: 'Add Tokens',
    width: 130,
    renderCell: (params) => (
      <Button
        color="success"
        variant="outlined"
        size="small"
        onClick={() => openAddTokensDialog(params.row)}
      >
        Add Tokens
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
];